import { Component, OnInit, Inject } from '@angular/core';
import { PhysicianService } from '../../../services/physician.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidateAutoCompleteSelect } from '../../../validators/autocomplete-select.validator';
import { CacheFilterService } from '../../../services/cache/cache-filter.service';
import { StudyReportService } from '../../../services/study-report/study-report.service';

@Component({
  selector: 'physicians-dialog',
  templateUrl: 'physicians-dialog.component.html',
  styleUrls: ['./physicians-dialog.component.css']
})
export class PhysiciansDialogComponent implements OnInit {

  loading: boolean;
  physicianFilters: PhysicianFilter[]= [];
  form: FormGroup;
    
  constructor(private cacheFilterService: CacheFilterService
    , private formBuilder: FormBuilder
    , private studyReportService: StudyReportService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<PhysiciansDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {
        this.form = this.formBuilder.group({
            physicians: ['', [Validators.required ]]
        });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  get f() { return this.form.controls; }

  async save() { 
    if ( this.form.valid ) {
        this.dialogRef.close(this.form.value.physicians.map(p => p.Id));
    } 
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.physicianFilters = await this.cacheFilterService.getPhysicianFilters();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Profesionales');
    } finally {
      this.loading = false;
    }
  }
}
